var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 63,
    viewBox: "0 0 79 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 63,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1289_586",
    transform: "scale(0.0126582 0.015873)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1289_586",
    width: 79,
    height: 63,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAAA/CAYAAAChFpVHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARdSURBVHgB1ZwNT9swEIZvLQUKA7Gx//8PGdOAjvIxlofWWpo4dmKfz+kjWaqSkFzeO58/YiNiy2VTfjTlixwH2Hm9Lz2WYgPP+d6Ui/3vk6Y8y7w5b8ptU86actqU96a8tS+wEI9ou5GdYA5+fzTlVeZHO9raNQQBcfiHO1BSPB78TXbi+aopHn2RnUfnwkr+R1sX3oFo3LgDpcRzRpxGrsOYA29WBCfj7EXgGs6h2WfKKSEeee1m5L3xJgJvpB7YgL1fR15PYHymHG3xrqSfK2IspV7+cw3Z2cS/4/rnE9ED761lOohWI/IQ7lbSat9DU940+lvcA+/F8psPhLsT+5xH1SO/pQr3yI/cyEO4270xU6GVvZc6wuHshUznSfbCSeINHDnCARFn3U3JEQ5bf7cPpIqXK9yDHJdwcNc9kHqjG0kXDtEexRZyW6wPF8Lr7JSb0RU5l3QexJacVhUQ7cl3Yqp49OMuJR0M+SN2uPSS059FOG+jNkU8RBvbCx/COurGjnRCDM7+jBUPA3KFgxexg1qSk15gK4GGbYx4LmfkdGvgVexaWETTcPY2dHKMIHhQYwxsNXbF1mvRIWhzTDzyXMp41ceb2KCR5xzJ4mnluVGGKIGzU8bYPv5KZOgYEu9K8vNc15iS4OycblSXqLOHxFmLXnV1lK62WrnZEZ2wWAQMOSYQTdvZ0ZriE28t+tPzpatsFWf7xCthSMk5uxJRB5OrbYmog5IrBEpFXdTmrngXUoaFlBGwVNSNYtExRKuP5KNEROeOXUNEv6gtjAyBqZ/3xqDZr+uCs4O1pS1e6fDX/MwJzGSXXmsTnC134i0lfVp9LNqRXSKSuwRtduKVzHXtZ2k+Zzbilc53ovwcbUcMEWxELSMPtPKqdv4MERRvJbqzJyG0IsbK2TDYorv1ZpZoVN3SjVubQYdzwrIKAFU3d7QxC4fXiDyXKnKwjDzwOrxG5InkNRxW+bn7zJXvYI09ETl5z7qmOHo2L6SeJ1NbzFobYLzi1fJkat6q4WxYSkerWobAsUUeHNhcUzzrFlOD2URerXSRQ0+80l+2QqQIWHO3UE+8OWxdmsJs9qohXs2dhylRPyvxahkTXUgT+LtaNh8sGUG8WpuGcyJ+K3U4cBrioWaNRiNn4Y/l8tw2B05zrW0NY3I26/ES1g7vbZN3/bwnseVV8iIP4Sy3JEBvJb8T70Vso0/DWZYO9+4faY8wrPZIbEQnanghK5u9z2mLR+SV9qb2vrONlO+2oInX2d3hEYn4TMqMO8lT2ttE6SfS1dL4LuKD3Hw/dNInEgKeiq6AbmNyiXXJCEitwemaEx3o8DN0wXLAGBemGksaMKKUcA6imghktldDQKrqr9hFsVAnAlM3hfBCj2LfDWLviPu3S1PB0dg8qucxNk/g0bWM+3Cz3ReSea0ZG7fGhK/9sUlXF7XUtkndtZQki1HdT5bv+0KCndsUF++42hf3vtiIaKSS5DH2PxyBs4a2Bj2dAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.29d3957f1ea06644d32a2e38b20f8a40.svg";
export { ForwardRef as ReactComponent };